module.exports = __webpack_public_path__ + "Flag-246.ff57cdaeeb5be39c50a54e01defe8c7e.svg";